import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Tag, Layers, Zap, Plus } from 'react-feather';
import PropTypes from 'prop-types';
import './CatalogueNav.css';

const CatalogueNav = ({ activeTabId, subtitle, addButtonText, onAddClick }) => {
    const location = useLocation();
    const navigate = useNavigate();

    const tabs = [
        { id: 'etiquettes', label: 'Étiquettes', path: '/etiquettes', icon: <Tag size={16} /> },
        { id: 'categories', label: 'Catégories', path: '/categorie', icon: <Layers size={16} /> },
        { id: 'articles', label: 'Articles', path: '/articles-new', icon: <Zap size={16} /> },
    ];

    // Determine current tab based on path if activeTabId is not provided
    const currentPath = location.pathname;
    const currentTab = activeTabId || tabs.find(tab => currentPath === tab.path)?.id || 'articles';

    return (
        <div className="catalogue-nav-container">
            <div className="catalogue-header">
                <div className="header-left">
                    <h1>Catalogue</h1>
                    <p>{subtitle}</p>
                </div>
                {addButtonText && (
                    <button className="btn-add-catalogue" onClick={onAddClick}>
                        <Plus size={18} className="d-md-none" />
                        <span className="d-none d-md-inline">{addButtonText}</span>
                    </button>
                )}
            </div>

            <div className="catalogue-tabs-container">
                <div className="catalogue-tabs-box">
                    {tabs.map((tab) => (
                        <div
                            key={tab.id}
                            className={`catalogue-tab-item ${currentTab === tab.id ? 'active' : ''}`}
                            onClick={() => navigate(tab.path)}
                        >
                            <span className="tab-icon">{tab.icon}</span>
                            <span className="tab-label">{tab.label}</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

CatalogueNav.propTypes = {
    activeTabId: PropTypes.string,
    subtitle: PropTypes.string,
    addButtonText: PropTypes.string,
    onAddClick: PropTypes.func
};

export default CatalogueNav;
